import { Colors } from "./Colors"

const tags = {
    bold: {
        fontFamily: "MassiliaBold",
    },
    bullet: {
        wrap: {
            mode: 'word',
            width: 700
        },
        x: 20

    },
}

export {
    tags
}